import { OsAllocationParams, OsAllocationResponse } from '../types/os-allocation';

import { SearchParamsOption } from 'ky';

import { handleRequest, privateClient } from '@data-access';

const OS_ALLOCATION_TIMEOUT_MS = 60_000;

function buildSearchParams({
  organizationIds,
  ownerIds,
  contractId,
}: OsAllocationParams = {}): SearchParamsOption {
  const searchParams: SearchParamsOption = {};
  if (organizationIds) {
    searchParams.organization =
      organizationIds.length > 0 ? organizationIds.join(',') : '';
  }
  if (ownerIds && ownerIds.length > 0) {
    searchParams.owner = ownerIds.join(',');
  }
  if (contractId) {
    searchParams.contract = String(contractId);
  }
  return searchParams;
}

export const osAllocationApi = {
  get: async (params: OsAllocationParams = {}) =>
    handleRequest<OsAllocationResponse>(
      privateClient
        .extend({ timeout: OS_ALLOCATION_TIMEOUT_MS })
        .get('os-allocation-simulation/', {
          searchParams: buildSearchParams(params),
        })
        .json(),
    ),
};
